
<p>
  Code licensed under MIT License.
  Documentation licensed under
  <a href="http://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>.
</p>
<p>
  Version {{versionInfo?.full}}.
</p>
